import { render, staticRenderFns } from "./Normcore.vue?vue&type=template&id=38cdce16&"
import script from "./Normcore.vue?vue&type=script&lang=js&"
export * from "./Normcore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports